import * as actions from './actionTypes'

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const typeRoadTestAction = (value) => ({
  type: actions.TYPE_ROAD_TEST,
  payload: {
    description: value,
  },
})

export const masterNumberAction = (value) => ({
  type: actions.MASTER_NUMBER,
  payload: {
    description: value.toUpperCase(),
  },
})

export const driverFirstNameAction = (value) => ({
  type: actions.DRIVER_FIRST_NAME,
  payload: {
    description: value,
  },
})

export const driverLastNameAction = (value) => ({
  type: actions.DRIVER_LAST_NAME,
  payload: {
    description: value,
  },
})

export const dateOfBirthAction = (value) => ({
  type: actions.DATE_OF_BIRTH,
  payload: {
    description: value,
  },
})

export const emailAddressAction = (value) => ({
  type: actions.EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const confirmEmailAddressAction = (value) => ({
  type: actions.CONFIRM_EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const driverPhoneNumberAction = (value) => ({
  type: actions.PHONE_NUMBER,
  payload: {
    description: value,
  },
})

export const masterNumberDOBAction = (value) => ({
  type: actions.MASTER_NUMBER_DOB,
  payload: {
    description: value,
  },
})

export const drivingSchoolNameAction = (value) => ({
  type: actions.DRIVING_SCHOOL_NAME,
  payload: {
    description: value,
  },
})

export const contactNameAction = (value) => ({
  type: actions.CONTACT_NAME,
  payload: {
    description: value,
  },
})

export const drivingPhoneNumberAction = (value) => ({
  type: actions.DRIVING_SCHOOL_PHONE_NUMBER,
  payload: {
    description: value,
  },
})

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})

export const clearAllFieldsAction = () => ({
  type: actions.CLEAR_ALL_FIELDS,
})
